import React from "react";
import TextField from "@material-ui/core/TextField/TextField";
import {useForm,} from "react-hook-form";
import {trimStart} from "lodash";

export type PropsTextNumberList = {
  label: string         // label
  value: number         // 入力値
  setValue: any         // 入力値セット関数
  index: number         // 配列番号
  valueList: number[]   // 配列
  minValue?: number      // 入力最小値
  maxValue?: number      // 入力最大値
  isDisabled: boolean   // 不活化
  required: boolean     // 必須
  message: string[]     // エラーメッセージ
  fieldName: string     // フィールド名
}

interface TextNumberListProps {
  propsTextList: PropsTextNumberList
};

// テキスト数値フィールド表示
export default function ApolloTextNumberList(props: TextNumberListProps) {

  const {errors, setError, clearErrors,} = useForm();

  const {
    label,
    value,
    setValue,
    index,
    valueList,
    minValue,
    maxValue,
    isDisabled,
    required,
    message,
    fieldName,
  } = props.propsTextList;

  let valueTemp = value;
  // テキストフィールド変更ハンドラ
  const handleChangeValue = (event: any) => {
    valueTemp = parseInt(event.target.value ? event.target.value : "0");
    event.target.value = trimStart(event.target.value, "0");
    valueList[index] = valueTemp;
    // ディープコピーすることで変更されいてることを感知させる
    setValue(JSON.parse(JSON.stringify(valueList)));
  };

  return (
    <div>
      <TextField
        id="id"
        name={fieldName}
        label={label}
        inputProps={message[index]
          ? {type: "number", min: minValue, style: {color: "red"}}
          : {type: "number", min: minValue}
        }
        required={required}
        fullWidth
        key={`${label}_${value}` ? "Loaded" : "Loading"}
        value={valueTemp}
        helperText={message[index] && message[index]}
        error={message[index] ? true : false}
        disabled={isDisabled}
        onChange={handleChangeValue}
        onKeyDown={((e) => {
          // 数値、Ctlr+(a-z)以外の入力は無視するように制御
          if(e.key.match(/^[^0-9\c[a-z]]$/)){
            e.preventDefault()
          }
        })}
      />
    </div>
  )
}
